import { Amplify, Storage } from "aws-amplify";
import aws_config from "../modified_aws-export";
import { IOptionType } from "../types/common";
import { toast } from "react-toastify";
import { VectorizedStatus } from "../types/vectorization";
import failedVectorization from "../assets/vectorization_failed.png";
import pendingVectorization from "../assets/vectorization_pending.gif";

export const S3_CONFIG: any = {
  bucket: aws_config.aws_data_exchange_bucket,
  region: aws_config.aws_user_files_s3_bucket_region,
  level: "public",
  customPrefix: { public: "" },
  validateObjectExistence: true,
};

export const VECTORIZATION_S3_CONFIG: any = {
  bucket: aws_config.vectorization_images_s3_bucket_name,
  region: aws_config.aws_appsync_region,
  level: "public",
  customPrefix: { public: "" },
  validateObjectExistence: true,
};

export const downloadImageAndConvertToFile = async (key: string) => {
  try {
    const result = await Storage.get(`image_similarity_search/${key}.png`, {
      download: true,
      bucket: aws_config.aws_user_files_s3_bucket,
      region: aws_config.aws_user_files_s3_bucket_region,
      customPrefix: { public: "" },
    });
    const blob = result.Body as Blob;
    return new File([blob], `${key}.png`, { type: blob.type || "image/png" });
  } catch (error) {
    console.error("Error downloading image:", error);
    return null;
  }
};

export const fetchManufacturers = async () => {
  let desiredListManufacturers = [];
  let manufacturerListUrl = await Storage.get(
    `in/tm-search-support/manufacturers.json`,
    { ...S3_CONFIG }
  );
  const responseManufacturers = await fetch(manufacturerListUrl).then((res) =>
    res.json()
  );

  for (let key of Object.keys(responseManufacturers)) {
    let desired: IOptionType = {
      value: key,
      label: responseManufacturers[key] + " (" + key + ")",
    };
    desiredListManufacturers.push(desired);
  }
  return desiredListManufacturers;
};

export const fetchItemGroups = async (selectedLanguage: string) => {
  const itemGroupsUrl = await Storage.get(`in/tm-search-support/item_groups.json`, {
    ...S3_CONFIG,
  });
  const responseItemGroups = await fetch(itemGroupsUrl).then((res) =>
    res.json()
  );
  return Object.keys(responseItemGroups[selectedLanguage]).map((key) => ({
    value: key,
    label: `${key.replace("-", "")} - ${
      responseItemGroups[selectedLanguage][key].ItemText
    }`,
  }));
};

export const fetchItemMPOptions = async () => {
  try {
    const result = await Storage.get("in/tm-search-support/item_mp_names.json", {
      download: true,
      bucket: aws_config.aws_data_exchange_bucket,
      region: aws_config.aws_user_files_s3_bucket_region,
      level: "public",
      customPrefix: { public: "" },
      validateObjectExistence: true,
    });
    if (result && typeof result === "object" && "Body" in result) {
      const text = await (result.Body as Blob).text();
      const data: string[] = JSON.parse(text);
      return data.map((item) => ({ value: item, label: item } as IOptionType));
    } else {
      console.error("Invalid file format or no content found.");
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const uploadImage = async (uploadFile: File) => {
  Amplify.configure(aws_config);
  Storage.configure({ level: "public" });
  return Storage.put(uploadFile.name, uploadFile, {
    contentType: "image/png",
    customPrefix: { public: "" },
  })
    .then((uploadresponse) => {
      return uploadresponse;
    })
    .catch((error) => {
      toast(error.toString(), { type: "error" });
    });
};

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
  return btoa(binary);
};

export const generateImageOutputURL = async (
  id: string,
  status: string
): Promise<string> => {
  switch (status) {
    case VectorizedStatus.COMPLETED: {
      const outputKey = `outputs/${id.split("#")[1]}`;
      try {
        const response = await Storage.get(outputKey, {
          ...VECTORIZATION_S3_CONFIG,
          download: true,
        });
        if (!response || !response.Body) {
          console.error(`Failed to fetch image: ${outputKey}`);
          return failedVectorization;
        }
        const arrayBuffer = await response.Body.arrayBuffer();
        const base64String = arrayBufferToBase64(arrayBuffer);
        return `data:image/svg+xml;base64,${base64String}`;
      } catch (error) {
        console.error(`Error fetching image from S3: ${error}`);
        return failedVectorization;
      }
    }
    case VectorizedStatus.PENDING:
      return pendingVectorization;
    case VectorizedStatus.PROCESSING:
      return pendingVectorization;
    case VectorizedStatus.FAILED:
    default:
      return failedVectorization;
  }
};
